import React from 'react';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import Tabs from '../common/Tabs';
import { TableHeader } from '../common/TableToolbar';
import Paper from '../common/layout/Paper';
import ProjectTypesScreen from '../project-types/ProjectTypesScreen';
import ProjectSubTypesScreen from '../project-sub-types/ProjectSubTypesScreen';
import ProjectSettingsDataScreen from '../settings/ProjectSettingsDataScreen';

export default function ProjectConfigurationScreen() {
	const location = useLocation();
	const theme = useTheme();

	const basePath = '/project-configuration';
	const panels = [
		{
			label: 'Project Types',
			component: <ProjectTypesScreen />,
			href: `${basePath}/types`,
			key: `${basePath}/types`,
		},
		{
			label: 'Project Sub Types',
			component: <ProjectSubTypesScreen />,
			href: `${basePath}/sub-types`,
			key: `${basePath}/sub-types`,
		},
		{
			label: 'Project Data',
			component: <ProjectSettingsDataScreen />,
			href: `${basePath}/data`,
			key: `${basePath}/data`,
		},
	];

	return (
		<>
			<Container gradientBorder>
				<Box
					sx={{
						width: '100%',
						backgroundColor: theme.palette.background.paper,
						borderRadius: 2,
						position: 'relative',
						flex: 1,
						overflow: 'auto',
						height: 'calc(100vh - 98px)',
						padding: 1,
					}}
				>
					<TableHeader>Project Settings</TableHeader>
					<Tabs panels={panels} currentPath={location.pathname} />
				</Box>
			</Container>
		</>
	);
}

const Container = styled(Paper)<{ $drawerOpen?: boolean }>`
	flex: 1;
	transition: width 0.3s ease-out;
	width: 100%;
`;
